import { InjectionToken } from '@angular/core';

export const GOOGLE_PLACES = new InjectionToken('google.places');
export const googlePlacesFactory = () => google.maps.places;
